import React from 'react';
import { useStrapi } from '../hooks/useStrapi';
import { getServices } from '../services/strapi';
import ServiceCard from '../components/ServiceCard';

const FALLBACK = [
  {
    attributes: {
      title: 'Complianceplatform',
      shortDescription: 'Komplet compliance-styring for din virksomhed. Automatiseret overvågning og rapportering.',
      icon: 'shield-check',
      externalUrl: 'https://complianceplatform.dk',
      features: ['Automatiseret overvågning', 'Dokumenthåndtering', 'GDPR compliance', 'NIS2 understøttelse', 'ISO 27001'],
    },
  },
  {
    attributes: {
      title: 'Risikovurderinger',
      shortDescription: 'Professionelle risikovurderinger tilpasset din virksomheds behov.',
      icon: 'chart-bar',
      externalUrl: 'https://risikovurderinger.dk',
      features: ['Risikoidentifikation', 'Kvantitativ vurdering', 'Handlingsplaner', 'Løbende opfølgning', 'Ledelsesrapportering'],
    },
  },
];

export default function ServicesPage() {
  const { data, loading, error } = useStrapi(getServices);
  // useStrapi already unwraps result.data, so data is the array directly
  const services = data || FALLBACK;

  return (
    <>
      <section className="hero" style={{ padding: '3rem 0' }}>
        <div className="container">
          <h1 className="hero__title" style={{ fontSize: '2.2rem' }}>Vores Services</h1>
          <p className="hero__subtitle">Professionelle løsninger til sikkerhed og compliance</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          {loading && <div className="loading">Indlæser services...</div>}
          {error && <div className="error">Kunne ikke hente data fra CMS. Viser standardindhold.</div>}
          <div className="cards">
            {services.map((svc, i) => (
              <ServiceCard key={svc.id || i} service={svc} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
